import {isSelectiveAiDomains} from 'common/HelperFunctions'

import {ForgotSetPasswordFlow} from '../../selective/ForgotSetPasswordFlow'
import {LegacyForgotPasswordNew} from './LegacyForgotPassword'

export function ForgotPassword() {
  if (isSelectiveAiDomains()) {
    return <ForgotSetPasswordFlow />
  }
  return <LegacyForgotPasswordNew />
}
